import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { strings } from '../../resources/strings';
import { assemblyDisapprovalOptions } from '../../resources/orderResources';
import { AssemblyDisapprovalType } from '../../enums/AssemblyDisapprovalType';
import ServicesContext from '../../contexts/ServicesContext';
import { Button } from '../../common-components/Button/Button';
import { Field, FieldType } from '../../common-components/Field/Field';

interface IModalDisapproveProps {
  visible: boolean;
  orderId?: number;
  close: () => void;
  registerAssemblyDisapproval?: (orderId: number, problemType: AssemblyDisapprovalType, problemDetails: string) => void;
}

const ModalDisapproveDegree: React.FC<IModalDisapproveProps> = ({
  visible,
  orderId,
  close,
  registerAssemblyDisapproval
}) => {

  const [problemType, setProblemType] = React.useState<AssemblyDisapprovalType | null | undefined>(null);
  const [problemDetails, setProblemDetails] = React.useState<string | null | undefined>('');

  const {
    toastService
} = React.useContext(ServicesContext);

  if (!visible) return null;

  return (
    <Modal
      show={visible}
      onHide={() => clickCloseModal()}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton style={{ height: '50px' }}>
        <Modal.Title>
          {strings.DisapproveDegree}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div style={{display: 'flex', flexDirection: 'column'}}>
          <Field
            type={FieldType.Select}
            label='Motivo'
            selectProps={{
              options: [ {type:'', description: ''}, ...assemblyDisapprovalOptions ],
              displayField: 'description',
              keyField: 'type'
            }}
            value={problemType}
            change={(value) => setProblemType(+value)}
            marginTop={'0px'}
          />
          <Field
            label='Detalhes'
            type={FieldType.TextArea}
            value={problemDetails}
            change={(value) => setProblemDetails(value)}
            marginTop='0px'
          />
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
          <Button text={strings.Save} width='100px' click={save} />
        </div>
      </Modal.Body>
    </Modal>
  );

  function clickCloseModal() {
    close();
  }

  function save() {
    if (!problemType) {
      toastService.warning('Informe o motivo da reprovação!');
      return;
    }

    const details = (problemDetails || '').trim();

    if (details.length === 0) {
      toastService.warning('Informe os detalhes da reprovação!');
      return;
    }

    registerAssemblyDisapproval && registerAssemblyDisapproval(orderId!, problemType, details);
  }
}

export { ModalDisapproveDegree };